import React from 'react';
import {
  Col, Container, Row,
} from 'react-bootstrap';

import Accordion from 'components/Accordion';
import RadioButton from 'components/DesignSystem/RadioButton';

export default function Version(
  { onChange, versions }: { onChange: (string) => void, versions: string[] },
) {
  return (
    <Accordion.Item eventKey="2">
      <Accordion.Header>Versão</Accordion.Header>
      <Accordion.Body>
        <Container>
          {versions.map((version) => (
            <Row key={version}>
              <Col key={version}>
                <RadioButton
                  name="version"
                  label={version}
                  onChange={onChange}
                  value={version}
                />
              </Col>
            </Row>
          ))}
        </Container>
      </Accordion.Body>
    </Accordion.Item>
  );
}
